export default "__VITE_ASSET__8e5b2d6c__"